import {useNavigate, useNavigation, useParams, useRouteLoaderData} from 'react-router-dom'
import React, {useState} from 'react'
import {Modal} from 'antd'
import {PlantRouteLoaderData} from '../App'
import {useMousePositionContext} from '../plantForm/usePlantModalMousePosition'
import {ToDo} from '../../entities/todoList'
import {
  CustomJournalEventType,
  JournalEventType,
  JournalRecord,
  ToDoType,
} from '../../entities/journalRecord'
import {JournalEventForm} from './JournalEventForm'

export type JournalEventModalProps = {
  routeWhenClosed: string
}

export function JournalEventModal({routeWhenClosed}: JournalEventModalProps) {
  const navigation = useNavigation()
  const navigate = useNavigate()
  const [isLoading, setLoading] = useState(false)
  const routeParams = useParams()
  const {mousePosition} = useMousePositionContext()

  const toDoPopupVisible = Boolean(routeParams.recordId) && !routeParams.plantId
  const plantLoading = toDoPopupVisible && navigation.state === 'loading'

  const {plantedPlantsNamesWithId, userJournalEventTypes, userJournalEvents} = useRouteLoaderData(
    'journal'
  ) as {
    plantedPlantsNamesWithId: {id: number; name: string}[]
    userJournalEventTypes: CustomJournalEventType[]
    userJournalEvents: {count: number; data: JournalRecord[]}
  }

  const recordId = Number(routeParams.recordId)
  const plantId = Number(routeParams.plantId)

  const record = useRouteLoaderData('journalRecordById') as JournalRecord | null

  const onClose = () => navigate(routeWhenClosed)

  const closeModal = () => {
    navigate(routeWhenClosed)
  }

  return (
    <Modal
      open={toDoPopupVisible}
      onCancel={onClose}
      mousePosition={mousePosition || undefined}
      footer={null}
      destroyOnHidden
      width={1000}
      loading={isLoading}
    >
      {record === null ? (
        <h2>Journal record with id {recordId} not found!</h2>
      ) : (
        <JournalEventForm
          //currentEvent={userJournalEvents.data.find((record) => record.id === recordId)}
          currentEvent={record}
          onFormClose={closeModal}
          setLoading={setLoading}
          editable={false}
          userJournalEventTypes={userJournalEventTypes}
        ></JournalEventForm>
      )}
    </Modal>
  )
}
